/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Language } from '../../models/language';

export interface LanguagesControllerFindOneByCode$Params {

/**
 * The language code
 */
  code: string;
}

export function languagesControllerFindOneByCode(http: HttpClient, rootUrl: string, params: LanguagesControllerFindOneByCode$Params, context?: HttpContext): Observable<StrictHttpResponse<Language>> {
  const rb = new RequestBuilder(rootUrl, languagesControllerFindOneByCode.PATH, 'get');
  if (params) {
    rb.path('code', params.code, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Language>;
    })
  );
}

languagesControllerFindOneByCode.PATH = '/languages/code/{code}';
